export default {"src":"/_next/static/media/gb-flag.aa21a691.svg","height":600,"width":1000,"blurWidth":0,"blurHeight":0};